// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function TextBox(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "TextBox" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M11 15V9H9V11H7V7H17V11H15V9H13V15H15V17H9V15H11Z", fill: "currentColor" }),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 2H2V5H3V19H2V22H5V21H19V22H22V19H21V5H22V2H19V3H5V2ZM19.5 19H19V19.5H5V19H4.5V5H5V4.5H19V5H19.5V19Z", fill: "currentColor" }))));
});
//# sourceMappingURL=TextBox.js.map